import { FC } from 'react'
import { DashboardCardProps } from './types.d'
import { ProgressBar } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CreateNewModule from '../../client/available-module/CreateNewModule'

const UNLIMITED_THRESHOLD = 9999

const Modules: FC<DashboardCardProps> = ({ widgetData }) => {
    const unlimited = widgetData.maxAllowedModules >= UNLIMITED_THRESHOLD
    const progressBarPercentage = unlimited
        ? 0
        : Math.round(
              (100 * widgetData.count) / widgetData.maxAllowedModules
          )
    const limitLabel = unlimited
        ? '∞'
        : `${widgetData.count}/${widgetData.maxAllowedModules}`
    const atLimit = !unlimited && widgetData.count >= widgetData.maxAllowedModules

    return (
        <div className="stat-card">
            <div
                className="stat-card__accent"
                style={{ background: 'linear-gradient(90deg, #f59e0b, #f97316)' }}
            />
            <div className="stat-card__header">
                <div>
                    <div className="stat-card__label text-warning">Modules</div>
                    <div className="stat-card__value text-warning">
                        {limitLabel}
                    </div>
                </div>
                <div
                    className="stat-card__icon"
                    style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }}
                >
                    <FontAwesomeIcon icon={['fas', 'cubes']} />
                </div>
            </div>
            {!unlimited && (
                <div className="stat-card__progress">
                    <ProgressBar
                        now={progressBarPercentage}
                        animated={progressBarPercentage < 100}
                        striped
                        variant="warning"
                        label={`${widgetData.count} of ${widgetData.maxAllowedModules}`}
                        visuallyHidden
                        style={{ height: '6px', borderRadius: '3px' }}
                    />
                </div>
            )}
            <div className="stat-card__action">
                {!atLimit ? (
                    <CreateNewModule
                        btnLabel="Add Module"
                        btnVariant="outline-warning"
                        btnClassName="btn-block w-100 btn-sm"
                    />
                ) : (
                    <a
                        href={process.env.REACT_APP_UPGRADE_PLAN_URL || 'https://samirify.com/pricing'}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-warning btn-block w-100 btn-sm"
                    >
                        Upgrade your plan
                    </a>
                )}
            </div>
        </div>
    )
}

export default Modules
